import 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

import { dateDisplayFormat, partyName } from '@/utilities'
import { bottomBorder } from './print-common'

const pdfMake = window.pdfMake
pdfMake.vfs = pdfFonts.pdfMake.vfs

export const printEngagementLetter = legalCase => {
  const docDefinition = {
    content: [
      {
        style: 'right',
        text: `Legal Case ID: ${legalCase.id}`,
      },
      {
        layout: bottomBorder,
        table: {
          body: [
            [
              {
                style: 'header',
                text: [
                  {
                    style: 'headerPrefix',
                    text: 'Engagement Letter',
                  },
                ],
              },
            ],
          ],
          widths: ['*'],
        },
      },
      { margin: 5, text: legalCase.legalCaseTypeTitle },
      { margin: 5, text: partiesNames(legalCase.parties) },
      { margin: 5, text: legalCase.engagement_letter_template },
    ],
    defaultStyle: {
      fontSize: 10,
    },

    styles,
  }

  if (legalCase.engagement_letter_signature) {
    docDefinition.content.push(
      { text: `Signature: ${legalCase.engagement_letter_signature}` },
      { text: `Signature date: ${dateDisplayFormat(legalCase.engagement_letter_signed_at)}` }
    )
  }

  pdfMake.createPdf(docDefinition).open()
}

// NOTE: pdfmake does not use the standard CSS rule (TRBL) for margins:
// Instead, margin: [left, top, right, bottom] (LTRB)
const styles = {
  header: {
    alignment: 'center',
    bold: true,
    fontSize: 14,
    margin: [0, 25, 0, 25],
  },
  headerPrefix: {
    color: 'gray',
    fontSize: 11,
  },
  right: {
    alignment: 'right',
  },
  table: {
    margin: [0, 5, 0, 15],
  },
}

const partiesNames = parties => parties.map(p => partyName(p)).join(', ')
